import { AxiosError } from 'axios';
import { IProduct, IProductAttributes, IProductsState } from 'contexts/Products/types';
import { createSelector } from 'reselect';

export const initialSelectors = {
  selectIndexedProducts: () => ({}),
  selectProduct: () => null,
};

export const selectLoadedState = (state: { loaded: boolean }) => state.loaded;
export const selectProducts = (state: { products: IProduct[] }) => state.products;
export const selectProductsByIds = (state: { productsByIds: IProduct[] }) => state.productsByIds;
export const selectLoadedProductsByIds = (state: { productsByIdsLoaded: boolean }) =>
  state.productsByIdsLoaded;
export const selectProductsAttributes = (state: { productsAttributes: IProductAttributes }) =>
  state.productsAttributes;
export const selectSearchProducts = (state: { searchProducts: IProduct[] }) => state.searchProducts;
export const selectSearchTotalCount = (state: { searchTotalCount: number }) =>
  state.searchTotalCount;
export const selectSyncError = (state: { error: AxiosError }) => state.error;
export const selectSyncState = (state: { syncing: boolean }) => state.syncing;
export const selectSyncById = (state: { syncingByIdCount: boolean }) => state.syncingByIdCount;

export const selectIndexedProducts = createSelector(selectProducts, (products) =>
  products.reduce((indexed: { [x: string]: any }, product: IProduct) => {
    if (product.id) {
      indexed[product.id] = product;
    }
    return indexed;
  }, {})
);
export const selectIndexedProductsByIds = createSelector(selectProductsByIds, (productsByIds) =>
  productsByIds.reduce((indexed: { [x: string]: any }, product: IProduct) => {
    if (product?.id) {
      indexed[product.id] = product;
    }
    return indexed;
  }, {})
);
export const selectIndexedSearchProducts = createSelector(selectSearchProducts, (products) =>
  products.reduce((indexed: { [x: string]: any }, product: IProduct) => {
    if (product.id) {
      indexed[product.id] = product;
    }
    return indexed;
  }, {})
);
export const selectProduct = createSelector(
  [selectIndexedProducts, (_: IProductsState, id: string) => id],
  (indexedProducts, id) => indexedProducts[id]
);
